var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600-494-231-86H210q17-51 56.5-88t93.5-48v-84h-20q-17 0-28.5-11.5T300-840q0-17 11.5-28.5T340-880h180q15 0 30 2t33 9q23 8 29 26.5t-6 35.5q-8 12-22 15t-28-2q-8-3-17-4.5t-19-1.5h-80v84q69 14 114.5 68.5T600-520v26ZM40-160v-280q0-33 23.5-56.5T120-520q33 0 56.5 23.5T200-440v280q0 33-23.5 56.5T120-80q-33 0-56.5-23.5T40-160Zm495 73-255-72v-361h64q7 0 14 1.5t14 3.5l277 103q14 5 22.5 18t8.5 27q0 21-14.5 34T632-320H527q-5 0-7.5-.5T513-323l-45-17q-8-3-16 1t-10 11q-2 8 1 15t11 10l59 21q2 1 6 1.5t7 .5h274q32 0 56 23t24 57L585-89q-10 4-24.5 4.5T535-87Zm225-473q-33 0-56.5-23.5T680-640q0-21 13.5-50t49.5-84q2-3 17-9 3 0 17 9 36 55 49.5 84t13.5 50q0 33-23.5 56.5T760-560Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanHands);
export default __webpack_public_path__ + "static/media/cleanHands.84bd53ae06d1d50e363b2adf8efede33.svg";
export { ForwardRef as ReactComponent };